import Input from "../../Input"

const ServerName = ({ values }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">اسم سرور متغیر</h6>
            <div className="font-sans">
                <label class="block mb-2 text-sm font-medium  text-gray-300">فرمت</label>
                <Input
                    type="text"
                    name="serverName-format"
                    placeholder="Format"
                    dir="ltr"
                    defaultValue={values?.format}
                />
            </div>

            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرها:</span>
                <div dir="ltr">
                    <div>%p: درصد انلاین ها</div>
                    <div>%c: تعداد انلاین ها</div>
                    <div>%s: اسلات سرور</div>
                </div>
            </div>
        </div>
    )
}

export default ServerName
